import styled from "styled-components";

export const SkeletonContainer = styled.div`
  width: 80%;
  margin-top: ${(props) => props.theme.space.xl};
`;
